import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: ()=> import('../views/miniprogram/UploadFile.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/uploadFile',
    name: 'uploadFile',
    component: ()=> import('../views/miniprogram/UploadFile.vue')
  },
  {
    path: '/GuidancePage',
    name: 'GuidancePage',
    component: ()=> import('../views/miniprogram/GuidancePage.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
